import { FC, useState } from "react";

import { Alert, Button, Input } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import styles from "./SampleType.module.scss";

import { ISampleType } from "@/models/SampleType";
import { SampleTypeList } from "@/modules/SampleType/components";
import { ERROR_500_MESSAGE } from "@/api/constants";
import { SampleTypesApi } from "@/api";

interface SampleTypeProps {
  sampleTypeList: ISampleType[];
  addSampleType: (sampleType: ISampleType) => void;
  editSampleType: (id: number, type: string) => void;
  deleteSampleType: (id: number) => void;
}

const SampleType: FC<SampleTypeProps> = ({
  sampleTypeList,
  addSampleType,
  editSampleType,
  deleteSampleType,
}) => {
  const [typeValue, setTypeValue] = useState("");
  const [addLoading, setAddLoading] = useState(false);
  const [addError, setAddError] = useState("");

  const addNewSampleType = () => {
    (async () => {
      try {
        setAddError("");
        setAddLoading(true);
        addSampleType(await SampleTypesApi.createSampleType(typeValue));
      } catch (e: any) {
        setAddError(e.message || ERROR_500_MESSAGE);
      } finally {
        setAddLoading(false);
      }
    })();
  };

  return (
    <div className={styles.container}>
      <Input.Group className={styles.input} compact>
        <Input
          style={{ width: "fit-content" }}
          disabled={addLoading}
          value={typeValue}
          onChange={(e) => setTypeValue(e.target.value)}
          placeholder="Add new"
        />
        <Button
          data-testid="add-new-type"
          loading={addLoading}
          disabled={addLoading}
          icon={<PlusOutlined />}
          type="primary"
          onClick={addNewSampleType}
        />
      </Input.Group>
      {addError && (
        <Alert className={styles.alert} type="error" description={addError} />
      )}
      <SampleTypeList
        sampleTypeList={sampleTypeList}
        editSampleType={editSampleType}
        deleteSampleType={deleteSampleType}
      />
    </div>
  );
};

export default SampleType;
